import styled from 'styled-components';

export const Spacer = styled.li`
    min-width: 20px;
`;
